import { mergeDeepRight } from 'ramda';

import { DeepPartial } from 'types/utils';

export function factory<Type extends Record<string, unknown>>(
  defaultValues: Type
) {
  return {
    get: () => defaultValues,
    with: (overrides: Partial<Type>): Type => {
      return {
        ...defaultValues,
        ...overrides,
      };
    },
    withDeep: (overrides: DeepPartial<Type>): Type => {
      return mergeDeepRight(defaultValues, overrides) as Type;
    },
  };
}
